import styled from 'styled-components';

export const BillingSubsidiaryLoadingStyled = styled.div`
  .billingSubsidiarySkeleton {
    &__container {
      width: 100%;
    }
  }

  :first-child {
    margin-bottom: 2px;
  }
`;
